"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiMenu = getMuiMenu;
exports.getMuiMenuItem = getMuiMenuItem;
function getMuiMenuItem(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          '&:hover': {
            backgroundColor: palette.grey[100]
          },
          backgroundColor: palette.grey[100]
        },
        '.MuiCheckbox-root': {
          paddingRight: '8px'
        },
        '.MuiLink-root': {
          '&:hover': {
            textDecoration: 'none'
          }
        },
        color: palette.common.black,
        padding: '6px 0'
      }
    }
  };
}
function getMuiMenu() {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '.MuiList-root': {
          padding: '16px'
        },
        boxShadow: '0px 2px 6px rgba(51, 51, 51, 0.15)'
      }
    }
  };
}